import { implementNode } from "../shared/implement.js";
import { BaseRange, parseExclusiveKey } from "./range.js";
export const minImplementation = implementNode({
    kind: "min",
    collapsibleKey: "rule",
    hasAssociatedError: true,
    keys: {
        rule: {},
        exclusive: parseExclusiveKey
    },
    normalize: schema => typeof schema === "number" ? { rule: schema } : schema,
    defaults: {
        description: node => `${node.exclusive ? "more than" : "at least"} ${node.rule}`
    },
    intersections: {
        min: (l, r) => (l.isStricterThan(r) ? l : r)
    }
});
export class MinNode extends BaseRange {
    impliedBasis = this.$.keywords.number.raw;
    traverseAllows = this.exclusive ? data => data > this.rule : data => data >= this.rule;
}
